import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'starArray' })
export class StarArrayPipe implements PipeTransform {
  transform(value: number | any[]): any[] {
    if (typeof value === 'number') {
      // Handle negative numbers by returning an empty array
      if (value < 0) {
        return [];
      }

      return Array(value).fill(0);
    }

    return value;
  }
}
